import { Link } from "react-router-dom";
import type { PeoplePage } from "../services/social";
import { Avatar, Empty } from "./Ui";
import { Icon } from "./Icon";

export function PeopleList({ people }: { people: PeoplePage["items"] }) {
  return people.length ? (
    <ul className="people-list">
      {people.map((person) => (
        <li key={person.username}>
          <Link to={`/user/${person.username}`} className="people-identity">
            <Avatar name={person.displayName || person.username} />
            <span>
              <strong>{person.displayName || person.username}</strong>
              <small>@{person.username}</small>
            </span>
            <Icon name="arrow" />
          </Link>
          <p>{person.bio}</p>
          <Link className="hint" to={`/user/${person.username}?tab=wikis`}>
            {person.publicRepositories ?? 0} public wikis
          </Link>
        </li>
      ))}
    </ul>
  ) : (
    <Empty title="No people here yet">
      <Link to="/explore/people">Explore the community</Link>
    </Empty>
  );
}
